export default {
      id: "file-circle-plus-usage",
      viewBox: "0 0 576 512",
      url: __webpack_public_path__ + "mysource_files/sprite-map.svg#file-circle-plus",
      toString: function () {
        return this.url;
      }
    }